import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FaComponent} from './fa.component';

@NgModule({
    declarations: [FaComponent],
    imports: [CommonModule],
    exports: [FaComponent],
})
export class FaModule {
}
